/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [":host{width:300px;height:200px}.overview-map{border:1px solid #005e95;box-shadow:0 1px 2px rgba(0,0,0,.3);width:100%;height:100%}"];
export { styles as styles };
